export enum SubfooterStatus{
    ACTIVE ="ACTIVE", 
    DELETED ="DELETED"
}


export class SubfooterRequestList{
    pageSize: number;
    pageNumber: number;
    
}


export class SubfooterRequest{
    index: number;
    province: string;
    
}

export class SubfooterRequestCreate extends SubfooterRequest {
    constructor(){super();}
}

export class SubfooterRequestUpdate extends SubfooterRequest {
    constructor(){super();}
}